<template>
  <div class="pages-download">
    <div class="the-banner"></div>
    <div class="bgbox-white">
      <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:20,offset:2}" :lg="{span:16,offset:4}">


                <div class="module-conts">
          <div class="module-title">
            <span class="title-cn">神行者加速器</span>
            <span class="title-en">SXZ ACCEL</span>
            <span class="title-info">- 神行者加速器安装包、更新包下载链接 -</span>
          </div>
          <div class="module-view">
            <div class="view-title">
              <span class="title-cn">神行者加速器</span>
              <span class="title-en">SMART ACCEL</span>
            </div>
            <div class="downconts-box">
              <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
                <div class="list-box">
                  <ul>
                    <!-- <li><span>版本：</span>1.1.6.32</li>
                    <li><span>MD5：</span>48003808d8b3849335eff278d190a17e</li> -->
                  </ul>
                </div>
              </el-col>
              <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
                <div class="downbtn-box">
                  <div class="downbtn downbtn-bdxz">
                    <a href="https://www.xspeeder.com/#/downloadaccel"  target="_blank">
                      <span>下载地址</span>
                    </a>
                  </div>
                  <!-- <div class="downbtn downbtn-wywp">
                    <a href="https://share.weiyun.com/PoR6Ev34" target="_blank" rel="noopener noreferrer">
                      <span>微云网盘下载</span>
                    </a>
                  </div>
                  <div class="downbtn downbtn-bdwp">
                    <a href="https://pan.baidu.com/s/15ew15dyUkCkZsRP5aVjN5g" target="_blank" rel="noopener noreferrer">
                      <span>百度网盘下载<br>提取码:2fpn</span>
                    </a>
                  </div> -->
                </div>
              </el-col>
            </div>
          </div>
          <!-- <div class="module-tools">
            <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:24}" :lg="{span:24}">
              <div class="tools-item">
                <div class="item item-az">
                  <a href="http://doc.xspeeder.com:808/Public/help/神行者智能桌面安装指南.pdf" target="_blank"
                     rel="noopener noreferrer">
                    <span>安装说明</span>
                  </a>
                </div>
              </div>
            </el-col>
          </div> -->
        </div>


        <div class="module-conts">
          <div class="module-title">
            <span class="title-cn">神行者路由下载</span>
            <span class="title-en">SXZ ROUTING DOWNLOAD</span>
            <span class="title-info">- 路由的安装包及安装、更新说明 -</span>
          </div>
          <div class="module-view">
            <div class="view-title">
              <span class="title-cn">路由安装ISO</span>
              <span class="title-en">ROUTING INSTALLATION ISO</span>
            </div>
            <div class="downconts-box">
              <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
                <div class="list-box">
                  <ul>
                    <li><span>版本：</span>22-1018-r4[2023-06-25]</li>
                    <li><span>MD5：</span>c362b2a414d601826d7b09b12ee81893</li>
                  </ul>
                </div>
              </el-col>
              <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
                <div class="downbtn-box">
                  <div class="downbtn downbtn-bdxz">
                    <a href="http://down.netsxz.com:84/iso/iso_1804_sxzros-20221018-r4.iso">
                      <span>本地下载</span>
                    </a>
                  </div>
                  <div class="downbtn downbtn-wywp">
                    <a href="https://share.weiyun.com/N4MjeMjF" target="_blank" rel="noopener noreferrer">
                      <span>微云网盘下载</span>
                    </a>
                  </div>
                  <div class="downbtn downbtn-bdwp">
                    <a href="https://pan.baidu.com/s/1TZ6mC_dyZn3DsmqZyFktPQ?pwd=4q64" target="_blank" rel="noopener noreferrer">
                      <span>百度网盘下载<br>提取码:4q64</span>
                    </a>
                  </div>
                </div>
              </el-col>
            </div>
          </div>
          <div class="module-view">
            <div class="view-title">
              <span class="title-cn">路由更新包 22-1018-r4</span>
              <span class="title-en">ROUTING UPDATE PACKET 22-1018-r4</span>
            </div>
            <div class="downconts-box">
              <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
                <div class="list-box">
                  <ul>
                    <li><span>版本：</span>22-1018-r4[2023-06-25]</li>
                    <li><span>MD5：</span>2a06d3277692104836edd8c66905f5fc</li>
                  </ul>
                </div>
              </el-col>
              <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
                <div class="downbtn-box">
                  <div class="downbtn downbtn-bdxz">
                    <a href="http://down.netsxz.com:84/release/up_xspatch_prd_22.10.18-r4-bin.tar.gz">
                      <span>本地下载</span>
                    </a>
                  </div>
                  <div class="downbtn downbtn-bdwp">
                    <a href="https://pan.baidu.com/s/1plfqr2X69ESH2VZoY7jrYw" target="_blank" rel="noopener noreferrer">
                      <span>百度网盘下载<br>提取码:nhk5</span>
                    </a>
                  </div>
                </div>
              </el-col>
            </div>
          </div>
<!--          <el-collapse accordion>-->
<!--            <el-collapse-item>-->
<!--              <template slot="title">-->
<!--                点击查看更多版本<i class="header-icon el-icon-info"></i>-->
<!--              </template>-->
<!--              <div class="module-view">-->
<!--                <div class="view-title">-->
<!--                  <span class="title-cn">路由更新包 19-1226-v6-r1</span>-->
<!--                  <span class="title-en">ROUTING UPDATE PACKET 19-1226-v6-r1</span>-->
<!--                </div>-->
<!--                <div class="downconts-box">-->
<!--                  <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">-->
<!--                    <div class="list-box">-->
<!--                      <ul>-->
<!--                        <li><span>版本：</span>19-1226-v6[2019-12-31]</li>-->
<!--                        <li><span>MD5：</span>460eaa3b3ba2a5bae830385042058866</li>-->
<!--                      </ul>-->
<!--                    </div>-->
<!--                  </el-col>-->
<!--                  <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">-->
<!--                    <div class="downbtn-box">-->
<!--                      <div class="downbtn downbtn-bdxz">-->
<!--                        <a href="http://down.netsxz.com:84/release/up_xspatch_ipv6_19.12.26-v6-r1.tar.gz">-->
<!--                          <span>本地下载</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                      <div class="downbtn downbtn-bdwp">-->
<!--                        <a href="https://pan.baidu.com/s/1IWUi42T7m-eJUITV4gYFgA" target="_blank"-->
<!--                           rel="noopener noreferrer">-->
<!--                          <span>百度网盘下载<br>提取码:hgpb</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </el-col>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="module-view">-->
<!--                <div class="view-title">-->
<!--                  <span class="title-cn">路由更新包 19-1017-v6-r4</span>-->
<!--                  <span class="title-en">ROUTING UPDATE PACKET 19-1017-v6-r4</span>-->
<!--                </div>-->
<!--                <div class="downconts-box">-->
<!--                  <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">-->
<!--                    <div class="list-box">-->
<!--                      <ul>-->
<!--                        <li><span>版本：</span>19-1017-v6[2019-10-29]</li>-->
<!--                        <li><span>MD5：</span>1956bcf1b20dfe4cdfb594e70a19d4c9</li>-->
<!--                      </ul>-->
<!--                    </div>-->
<!--                  </el-col>-->
<!--                  <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">-->
<!--                    <div class="downbtn-box">-->
<!--                      <div class="downbtn downbtn-bdxz">-->
<!--                        <a href="http://down.netsxz.com:84/release/up_xspatch_ipv6_19.10.17-v6-r4.tar.gz">-->
<!--                          <span>本地下载</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                      <div class="downbtn downbtn-bdwp">-->
<!--                        <a href="https://pan.baidu.com/s/1JB0FUChPgDCKGqEWo4JuyQ" target="_blank"-->
<!--                           rel="noopener noreferrer">-->
<!--                          <span>百度网盘下载<br>提取码:a7am</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </el-col>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="module-view">-->
<!--                <div class="view-title">-->
<!--                  <span class="title-cn">路由更新包 19-0624-r2</span>-->
<!--                  <span class="title-en">ROUTING UPDATE PACKET 19-0624-r2</span>-->
<!--                </div>-->
<!--                <div class="downconts-box">-->
<!--                  <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">-->
<!--                    <div class="list-box">-->
<!--                      <ul>-->
<!--                        <li><span>版本：</span>19-624[2019-07-17]</li>-->
<!--                        <li><span>MD5：</span>cfd7aaee15d580817345860273f1d4b2</li>-->
<!--                      </ul>-->
<!--                    </div>-->
<!--                  </el-col>-->
<!--                  <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">-->
<!--                    <div class="downbtn-box">-->
<!--                      <div class="downbtn downbtn-bdxz">-->
<!--                        <a href="http://down.netsxz.com:84/release/up_xspatch_19.06.24-1-r2.tar.gz">-->
<!--                          <span>本地下载</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                      <div class="downbtn downbtn-bdwp">-->
<!--                        <a href="https://pan.baidu.com/s/1KBrPyd-0st-IydBig43r5g" target="_blank"-->
<!--                           rel="noopener noreferrer">-->
<!--                          <span>百度网盘下载<br>提取码:u9lf</span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </el-col>-->
<!--                </div>-->
<!--              </div>-->
<!--            </el-collapse-item>-->
<!--          </el-collapse>-->

          <div class="module-tools">
            <el-col :xs="{span:12}" :sm="{span:12}" :md="{span:6}" :lg="{span:6}">
              <div class="tools-item">
                <div class="item item-gx">
                  <a href="http://doc.xspeeder.com:808/Public/help/sxzros_list" target="_blank"
                     rel="noopener noreferrer">
                    <span>更新说明</span>
                  </a>
                </div>
              </div>
            </el-col>
            <el-col :xs="{span:12}" :sm="{span:12}" :md="{span:6}" :lg="{span:6}">
              <div class="tools-item">
                <div class="item item-az">
                  <a href="http://doc.xspeeder.com:808/Public/help/神行者路由安装.pdf" target="_blank"
                     rel="noopener noreferrer">
                    <span>安装说明</span>
                  </a>
                </div>
              </div>
            </el-col>
            <el-col :xs="{span:12}" :sm="{span:12}" :md="{span:6}" :lg="{span:6}">
              <div class="tools-item">
                <div class="item item-js">
                  <a href="http://doc.xspeeder.com:808/Public/help/神行者路由技术白皮书.pdf" target="_blank"
                     rel="noopener noreferrer">
                    <span>技术白皮书</span>
                  </a>
                </div>
              </div>
            </el-col>
            <el-col :xs="{span:12}" :sm="{span:12}" :md="{span:6}" :lg="{span:6}">
              <div class="tools-item">
                <div class="item item-sy">
                  <a href="http://doc.netsxz.com/" target="_blank" rel="noopener noreferrer">
                    <span>使用手册</span>
                  </a>
                </div>
              </div>
            </el-col>
          </div>
        </div>
        <div class="module-conts">
          <div class="module-title">
            <span class="title-cn">神行者智慧电视桌面系统下载</span>
            <span class="title-en">SXZ SMART TV DESKTOP SYSTEM DOWNLOAD</span>
            <span class="title-info">- 智慧电视桌面系统安装包、更新包下载 -</span>
          </div>
          <div class="module-view">
            <div class="view-title">
              <span class="title-cn">智慧电视桌面系统安装包</span>
              <span class="title-en">SMART TV DESKTOP SYSTEM INSTALLATION PACKAGE</span>
            </div>
            <div class="downconts-box">
              <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
                <div class="list-box">
                  <ul>
                    <li><span>版本：</span>20200612[2020-06-23]</li>
                    <li><span>MD5：</span>5b5d0b9c9bacf54fed09213dead05413</li>
                  </ul>
                </div>
              </el-col>
              <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
                <div class="downbtn-box">
                  <div class="downbtn downbtn-bdxz">
                    <a href="http://down.netsxz.com:84/sd-media/sd-media_1804_20200612.iso">
                      <span>本地下载</span>
                    </a>
                  </div>
                  <div class="downbtn downbtn-wywp">
                    <a href="https://share.weiyun.com/PoR6Ev34" target="_blank" rel="noopener noreferrer">
                      <span>微云网盘下载</span>
                    </a>
                  </div>
                  <div class="downbtn downbtn-bdwp">
                    <a href="https://pan.baidu.com/s/15ew15dyUkCkZsRP5aVjN5g" target="_blank" rel="noopener noreferrer">
                      <span>百度网盘下载<br>提取码:2fpn</span>
                    </a>
                  </div>
                </div>
              </el-col>
            </div>
          </div>
          <div class="module-view">
            <div class="view-title">
              <span class="title-cn">APK安装包</span>
              <span class="title-en">APK INSTALLATION PACKAGE</span>
            </div>
            <div class="downconts-box">
              <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
                <div class="list-box">
                  <ul>
                    <li><span>版本：</span>20250427[2025-04-27]</li>
                    <li><span>MD5：</span>—</li>
                  </ul>
                </div>
              </el-col>
              <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
                <div class="downbtn-box">
                  <div class="downbtn downbtn-bdxz">
                    <a href="http://down.netsxz.com:84/sd-media/apk/sd-media-APK-20240527.rar">
                      <span>本地下载</span>
                    </a>
                  </div>
                  <div class="downbtn downbtn-wywp">
                    <a href="https://share.weiyun.com/5R4qLGQ" target="_blank" rel="noopener noreferrer">
                      <span>微云网盘下载</span>
                    </a>
                  </div>
                  <div class="downbtn downbtn-bdwp">
                    <a href="https://pan.baidu.com/s/18m9oTIbw5kFMRtLTu1uCNg" target="_blank" rel="noopener noreferrer">
                      <span>百度网盘下载</span>
                    </a>
                  </div>
                </div>
              </el-col>
            </div>
          </div>
          <div class="module-tools">
            <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:24}" :lg="{span:24}">
              <div class="tools-item">
                <div class="item item-az">
                  <a href="http://doc.xspeeder.com:808/Public/help/神行者智能桌面安装指南.pdf" target="_blank"
                     rel="noopener noreferrer">
                    <span>安装说明</span>
                  </a>
                </div>
              </div>
            </el-col>
          </div>
        </div>
        <div class="module-conts">
          <div class="module-title">
            <span class="title-cn">神行者日志</span>
            <span class="title-en">SXZ LOG DOWNLOAD</span>
            <span class="title-info">- 路由上网使用日志下载 -</span>
          </div>
          <div class="module-view">
            <div class="view-title">
              <span class="title-cn">日志安装包</span>
              <span class="title-en">LOG INSTALLATION PACKAGE</span>
            </div>
            <div class="downconts-box">
              <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
                <div class="list-box">
                  <ul>
                    <li><span>版本：</span>神行者日志[2023-09-04]</li>
                    <li><span>MD5：</span>—</li>
                  </ul>
                </div>
              </el-col>
              <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
                <div class="downbtn-box">
                  <div class="downbtn downbtn-bdxz">
                    <a href="http://down.netsxz.com:84/xslog/euler-sp1-smartassist-0904.iso">
                      <span>本地下载</span>
                    </a>
                  </div>
                  <div class="downbtn downbtn-bdwp">
                    <a href="https://pan.baidu.com/s/1HVCMHuaM5hGumI8vGHfXkQ?pwd=edh9" target="_blank" rel="noopener noreferrer">
                      <span>百度网盘下载<br>提取码:edh9</span>
                    </a>
                  </div>
                </div>
              </el-col>
            </div>
          </div>
          <div class="module-view">
            <div class="view-title">
              <span class="title-cn">日志更新包</span>
              <span class="title-en">LOG UPDATE PACKAGE</span>
            </div>
            <div class="downconts-box">
              <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
                <div class="list-box">
                  <ul>
                    <li><span>版本：</span>20230904[2023-09-04]</li>
                    <li><span>MD5：</span>—</li>
                  </ul>
                </div>
              </el-col>
              <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
                <div class="downbtn-box">
                  <div class="downbtn downbtn-bdxz">
                    <a href="http://down.netsxz.com:84/xslog/smartassist-clickhouse-230904-bin.tar.gz">
                      <span>本地下载</span>
                    </a>
                  </div>
                  <div class="downbtn downbtn-bdwp">
                    <a href="https://pan.baidu.com/s/1QC8UIvcn4yShtweG14fG3Q?pwd=qv2t" target="_blank" rel="noopener noreferrer">
                      <span>百度网盘下载<br>提取码:qv2</span>
                    </a>
                  </div>
                </div>
              </el-col>
            </div>
          </div>
          <div class="module-tools">
            <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:24}" :lg="{span:24}">
              <div class="tools-item">
                <div class="item item-az">
                  <a href="http://doc.xspeeder.com:808/Public/help/神行者日志安装教程.pdf" target="_blank"
                     rel="noopener noreferrer">
                    <span>安装说明</span>
                  </a>
                </div>
              </div>
            </el-col>
          </div>
        </div>
        <div class="module-conts">
          <div class="module-title">
            <span class="title-cn">神行者缓存下载</span>
            <span class="title-en">SXZ CACHE DOWNLOAD</span>
            <span class="title-info">- 缓存的安装包及安装、配置说明 -</span>
          </div>
          <div class="module-view">
            <div class="view-title">
              <span class="title-cn">Linux版本缓存安装ISO</span>
              <span class="title-en">LINUX VERSION CACHE INSTALLATION ISO</span>
            </div>
            <div class="downconts-box">
              <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
                <div class="list-box">
                  <ul>
                    <li><span>版本：</span>16.06.12[2016-09-13]</li>
                    <li><span>MD5：</span>7f4142fc98296649ae1faca6bb4e01e0</li>
                  </ul>
                </div>
              </el-col>
              <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
                <div class="downbtn-box">
                  <div class="downbtn downbtn-bdxz">
                    <a href="http://down.netsxz.com:84/iso/dwcache4.10.iso">
                      <span>本地下载</span>
                    </a>
                  </div>
                  <div class="downbtn downbtn-wywp">
                    <a href="https://share.weiyun.com/5c6jcjV" target="_blank" rel="noopener noreferrer">
                      <span>微云网盘下载</span>
                    </a>
                  </div>
                  <div class="downbtn downbtn-bdwp">
                    <a href="http://pan.baidu.com/s/1jHWwRwM" target="_blank" rel="noopener noreferrer">
                      <span>百度网盘下载</span>
                    </a>
                  </div>
                </div>
              </el-col>
            </div>
          </div>
          <div class="module-tools">
            <el-col :xs="{span:12}" :sm="{span:8}" :md="{span:8}" :lg="{span:8}">
              <div class="tools-item">
                <div class="item item-az">
                  <a href="http://doc.xspeeder.com:808/Public/help/setupGUI.pdf" target="_blank"
                     rel="noopener noreferrer">
                    <span>安装说明</span>
                  </a>
                </div>
              </div>
            </el-col>
            <el-col :xs="{span:12}" :sm="{span:8}" :md="{span:8}" :lg="{span:8}">
              <div class="tools-item">
                <div class="item item-js">
                  <a href="http://doc.xspeeder.com:808/Public/help/缓存技术白皮书.pdf" target="_blank"
                     rel="noopener noreferrer">
                    <span>技术白皮书</span>
                  </a>
                </div>
              </div>
            </el-col>
            <el-col :xs="{span:12}" :sm="{span:8}" :md="{span:8}" :lg="{span:8}">
              <div class="tools-item">
                <div class="item item-sy">
                  <a href="http://doc.xspeeder.com:808/Public/help/config.pdf" target="_blank"
                     rel="noopener noreferrer">
                    <span>使用手册</span>
                  </a>
                </div>
              </div>
            </el-col>
          </div>
        </div>
        <div class="module-conts">
          <div class="module-title">
            <span class="title-cn">XWANClient软终端下载</span>
            <span class="title-en">XWANClient download</span>
          </div>
          <div class="module-view">
            <div class="view-title">
              <span class="title-cn">Windows</span>
              <span class="title-en">windows</span>
            </div>
            <div class="downconts-box">
              <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
                <div class="list-box">
                  <ul>
                    <li><span>版本：</span>1.0.1.14</li>
                    <li><span>MD5：9001b7ba6a6845f74b0717d293add7b7</span></li>
                  </ul>
                </div>
              </el-col>
              <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
                <div class="downbtn-box">
                  <div class="downbtn downbtn-windows">
                    <a href="https://down.netsxz.com:8443/Client/Setup.exe" target="_blank"
                       rel="noopener noreferrer">
                      <span>Windows下载</span>
                    </a>
                  </div>
                </div>
              </el-col>
            </div>
          </div>
          <div class="module-view">
            <div class="view-title">
              <span class="title-cn">Android</span>
              <span class="title-en">android</span>
            </div>
            <div class="downconts-box">
              <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
                <div class="list-box">
                  <ul>
                    <li><span>版本：</span>1.0.16</li>
                    <li><span>MD5：53857614b27da9c49423212ac2e2cc82</span></li>
                  </ul>
                </div>
              </el-col>
              <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
                <div class="downbtn-box">
                  <div class="downbtn downbtn-andorid">
                    <a href="https://down.netsxz.com:8443/Client/sdwan.apk" target="_blank" rel="noopener noreferrer">
                      <span>Android下载</span>
                    </a>
                  </div>
                </div>
              </el-col>
            </div>
          </div>
          <div class="module-view">
            <div class="view-title">
              <span class="title-cn">IOS & MAC</span>
              <span class="title-en">ios & mac</span>
            </div>
            <div class="downconts-box">
              <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
                <div class="list-box">
                  <ul>
                    <li><span>版本：</span>1.0.12</li>
                    <!--                    <li><span>MD5：53857614b27da9c49423212ac2e2cc82</span></li>-->
                  </ul>
                </div>
              </el-col>
              <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
                <div class="downbtn-box">
                  <div class="downbtn downbtn-ios">
                    <a href="https://apps.apple.com/cn/app/xwanclient/id1546185886" target="_blank"
                       rel="noopener noreferrer">
                      <span>IOS,MAC下载</span>
                    </a>
                  </div>
                </div>
              </el-col>
            </div>
          </div>
        </div>
        <div class="module-conts">
          <div class="module-title">
            <span class="title-cn">常用工具下载</span>
            <span class="title-en">Common tools download</span>
            <span class="title-info">- 常用工具安装包 -</span>
          </div>
          <div class="module-view">
            <div class="view-title">
              <span class="title-cn">UltraISO</span>
              <span class="title-en">ULTRAISO</span>
            </div>
            <div class="downconts-box">
              <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
                <div class="list-box">
                  <ul>
                    <li><span>版本：</span>9.6.5.3237</li>
                    <li><span>MD5：</span>—</li>
                  </ul>
                </div>
              </el-col>
              <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
                <div class="downbtn-box">
                  <div class="downbtn downbtn-bdwp">
                    <a href="http://pan.baidu.com/s/1i4tztm1" target="_blank" rel="noopener noreferrer">
                      <span>百度网盘下载</span>
                    </a>
                  </div>
                </div>
              </el-col>
            </div>
          </div>
          <div class="module-view">
            <div class="view-title">
              <span class="title-cn">MD5</span>
              <span class="title-en">MD5</span>
            </div>
            <div class="downconts-box">
              <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
                <div class="list-box">
                  <ul>
                    <li>Windows 7 及以上版本，可以使用命令行来计算文件的MD5值</li>
                    <li>
                      <pre>>certutil -hashfile d:\dwcache4.10.iso MD5</pre>
                    </li>
                  </ul>
                </div>
              </el-col>
            </div>
          </div>
        </div>
      </el-col>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>
<style>
.el-collapse-item__header {
  font-size: 20px;
  color: #06c;
}
</style>
<style lang="scss" scoped>
.the-banner {
  height: 400px;
  background-image: url("../../assets/images/download-banner1.jpg");
  background-repeat: no-repeat;
  background-position: center;
}

.bgbox-white {
  padding: 50px 10px;
  overflow: hidden;
  background: #fff;
  box-sizing: border-box;
}

.module-title {
  text-align: center;
  padding-bottom: 40px;

  .title-cn {
    display: block;
    font-size: 30px;
    font-weight: bold;
    color: #1f1f1f;
  }

  .title-en {
    display: block;
    font-size: 12px;
    font-weight: 400;
    color: #757575;
    line-height: 20px;
  }

  .title-info {
    display: block;
    font-size: 14px;
    color: #999999;
  }
}

.view-title {
  .title-cn {
    display: block;
    font-size: 20px;
    color: #1f1f1f;
    font-family: "PingFang SC";
  }

  .title-en {
    display: block;
    font-size: 12px;
    color: #757575;
    line-height: 20px;
    padding-left: 20px;
    box-sizing: border-box;
    position: relative;

    &::before {
      content: '';
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: #3067ba;
      position: absolute;
      left: 0;
      top: 6px;
    }
  }
}

// 下载内容共用部分
.module-conts {
  padding-bottom: 80px;
}

.module-view {
  padding-bottom: 40px;
}

.downconts-box {
  overflow: hidden;

  .list-box {
    ul {
      padding: 10px 0;
      margin: 0;

      li {
        list-style: none;
        font-size: 16px;
        color: #1f1f1f;
        padding: 10px 0;
        border-bottom: 1px solid #e3e6e7;

        span {
          color: #757575;
        }

        pre {
          margin: 0;
          background: #333;
          color: #fff;
          padding: 6px;
          box-sizing: border-box;
        }
      }
    }
  }

  .downbtn-box {
    float: right;
    text-align: right;

    .downbtn {
      width: 100px;
      height: 100px;
      background: #0066cc;
      display: inline-block;
      vertical-align: top;
      margin-right: 20px;
      background-size: 60px !important;
      background-position: center 10px !important;
      cursor: pointer;
      position: relative;

      &:last-child {
        margin: 0;
      }

      &.downbtn-bdxz {
        background: url("../../assets/images/download-icon1.png") #0066cc no-repeat;
      }

      &.downbtn-wywp {
        background: url("../../assets/images/download-icon2.png") #0066cc no-repeat;
      }

      &.downbtn-bdwp {
        background: url("../../assets/images/download-icon3.png") #0066cc no-repeat;
      }

      &.downbtn-andorid {
        background: url("../../assets/images/android.png") #0066cc no-repeat;
      }

      &.downbtn-ios {
        background: url("../../assets/images/ios.png") #0066cc no-repeat;
      }
      &.downbtn-windows {
        background: url("../../assets/images/Windows.png") #0066cc no-repeat;
      }

      a {
        display: block;
        width: 100%;
        height: 100%;
      }

      span {
        display: block;
        width: 100%;
        font-size: 14px;
        color: #fff;
        text-align: center;
        position: absolute;
        bottom: 10px;
        line-height: 1;
      }
    }
  }
}

.module-tools {
  overflow: hidden;
  background: #f5f5f5;

  .tools-item {
    width: 120px;
    height: 150px;
    margin: 0 auto;
    padding: 10px;
    box-sizing: border-box;

    .item {
      width: 100%;
      height: 100%;
      cursor: pointer;
      background-size: 87px !important;
      background-position: center 10px !important;
      position: relative;
      transition: all 0.3s ease;

      &.item-gx {
        background: url("../../assets/images/download-icon4.png") no-repeat;
      }

      &.item-az {
        background: url("../../assets/images/download-icon5.png") no-repeat;
      }

      &.item-js {
        background: url("../../assets/images/download-icon6.png") no-repeat;
      }

      &.item-sy {
        background: url("../../assets/images/download-icon7.png") no-repeat;
      }

      a {
        display: block;
        width: 100%;
        height: 100%;
      }

      span {
        font-size: 18px;
        color: #1f1f1f;
        position: absolute;
        bottom: 6px;
        width: 100%;
        text-align: center;
      }

      &:hover {
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      }
    }
  }
}


// 中等屏幕
@media screen and (max-width: 991px) {
  .downconts-box {
    .downbtn-box {
      float: left;
      text-align: left;

      .downbtn {
        width: 80px;
        height: 80px;
        margin-right: 10px;
        background-size: 40px !important;

        span {
          font-size: 12px;
        }
      }
    }
  }

}

// 移动端css
@media screen and (max-width: 767px) {
  .the-banner {
    height: 260px;
    background-image: url("../../assets/images/download-banner2.jpg");
  }
}
</style>
